import React from "react";
import { Pagination as BsPagination } from "react-bootstrap";

interface PaginationProps {
  rows: Array<any>;
  activePageNumber: number;
  setActivePageNumber: Function;
  hasNext: boolean;
}

function PaginationPrecalculated({
  activePageNumber,
  setActivePageNumber,
  hasNext
}: PaginationProps) {
  const showsBack = activePageNumber > 1;

  return (
    <BsPagination>
      {showsBack && (
        <BsPagination.Prev
          onClick={() => setActivePageNumber(activePageNumber - 1)}
        />
      )}
      <BsPagination.Item
        active={true}
      >
        {activePageNumber}
      </BsPagination.Item>
      {hasNext && (
        <BsPagination.Next
          onClick={() => setActivePageNumber(activePageNumber + 1)}
        />
      )}
    </BsPagination>
  );
}

export default PaginationPrecalculated;
